import { useAuthStore } from '../lib/authStore.js';

export function usePermission(code: string): boolean {
  const perms = useAuthStore((s) => s.permissions);
  return perms.includes(code);
}

export function useAnyPermission(codes: readonly string[]): boolean {
  const perms = useAuthStore((s) => s.permissions);
  return codes.some((c) => perms.includes(c));
}

/**
 * The shop's owner — the only holder of the capabilities that must not be
 * delegable to a role (mirrors `requireRole('owner')` on the API).
 *
 * Hiding a control is presentation, never protection: the server decides. This
 * exists so the UI does not offer an action it knows will be refused.
 */
export function useIsOwner(): boolean {
  const roles = useAuthStore((s) => s.roles);
  return roles.includes('owner');
}
